import {createAction} from '@reduxjs/toolkit'
import {getEventId} from '@wix/wix-events-commons-statics'
import {getEvent} from '../selectors/event'
import {getReservationId} from '../selectors/reservation'
import {GetState} from '../types/state'
import {getDiscount} from './checkout'

export const removeCoupon = () => (dispatch: Function, getState: GetState) => {
  const state = getState()

  dispatch(resetCouponCode())
  dispatch(getDiscount({eventId: getEventId(getEvent(state)), reservationId: getReservationId(state)}))
}

export const resetCouponCode = createAction('RESET_COUPON_CODE')

export const submitCoupon = createAction<string>('SUBMIT_COUPON')

export const couponApplied = createAction('COUPON_APPLIED')

export const applyCoupon = (eventId: string, reservationId: string, couponCode: string) => (dispatch: Function) => {
  dispatch(submitCoupon(couponCode))
  return dispatch(getDiscount({eventId, reservationId}))
}
